<template>
    <div class="dynamic-map-3d" id="map3D" v-cloak>
        <div id="wee3dCanvas" class="wee3dCanvas wee3d" style="width: 100%; left: 0px; background-image: radial-gradient(rgb(125, 152, 196), rgb(24, 32, 45)); overflow: hidden">
            <!-- 进度条 -->
            <div v-show="loading" class="loading" style="background-image: radial-gradient(rgb(125, 152, 196), rgb(24, 32, 45))">
                <div class="loadingArea">
                    <div class="loadingPercent" style="font-size: 36px"></div>
                </div>
            </div>

            <!-- 按钮放大 -->
            <div v-show="!loading" class="seemore" :title="isFullScreen === true ? '打开全屏' : '退出全屏'" @click="fullScreen">
                <a-icon type="arrows-alt" v-if="isFullScreen === false" />
                <a-icon type="close" v-if="isFullScreen === true" />
            </div>

            <h4 v-show="!loading" class="wee3d-title">
                <img src="../assets/images/smart_logo_white_2.svg" style="margin-top: -6px" />
                <span style="margin-left: 10px;">数字化车间</span>
            </h4>

            <a-divider v-show="!loading" class="wee3d-divider"/>

            <div v-show="!loading" style="color: white; margin-left: 25px; position: relative; z-index: 100; display: block">
                <a-row class="wrap-row-extr">
                    <a-col :span="12" style="text-align: left">
                        <span style="font-size: 48px;">转子车间</span>
                    </a-col>

                    <a-col :span="12" class="wee3d-button" style="text-align: right">
                        <div class="wee3d-btn-all">
                            <a-button class="wee3d-btn" v-if="isPlay" @click="pause">暂停</a-button>
                            <a-button class="wee3d-btn" v-if="!isPlay" @click="play">播放</a-button>
                            <a-button class="wee3d-btn" @click="freeCamera">鸟瞰模式</a-button>
                        </div>
                    </a-col>
                </a-row>
            </div>

            <div class="asset-parent">
                <div class="asset-left">
                    <transition-group name="slide-fade-left">
                        <template v-for="(item) in showLeftAssetItems">
                            <BasicAssetCard
                                :key="item.id"
                                class="asset-class slide-fade-left-item"
                                :asset-card="item.title"
                                :asset-info="item.assetInfo"
                            />
                        </template>
                    </transition-group>
                </div>
                <div class="asset-right">
                    <transition-group name="slide-fade-right">
                        <template v-for="(item) in showRightAssetItems">
                            <BasicAssetCard
                                :key="item.id"
                                class="asset-class slide-fade-right-item"
                                :asset-card="item.title"
                                :asset-info="item.assetInfo"
                            />
                        </template>
                    </transition-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import tools from '../tools/tools'
    import moment from 'moment'
    import assetJson from '../json/asset'
    import workingJson from '../json/working'
    import queueJson from '../json/queue'
    import BasicAssetCard from '@/components/BasicAssetCard'

    export default {
        name: 'DetailDynamicMap3D',

        components: {BasicAssetCard},

        props: [],

        data ()
        {
            return {
                loading: true,                      // 表示加载中
                allAssetItems: [],                  // 所有的设备数据
                workingTaskItems: [],               // 正在加工的任务
                queueTaskItems: [],                 // 排队的任务
                showLeftAssetItems: [],             // 显示在左边的设备数据
                showRightAssetItems: [],            // 显示在右边的设备数据
                wee3d: null,                        // wee 3D 对象
                isFullScreen: false,                // 是否为全屏模式
                loadHeight: '100%',                 // loading 样式的高度
                defaultDis: 15,                     // 默认为15桢的情况下进行设备显示
                isPlay: true,                       // 是否处理播放状态
            }
        },

        computed: {
            ...mapGetters({
            })
        },

        watch: {},

        mounted: function ()
        {
            let self = this

            // 默认高度
            self.loadHeight = tools.screenHeight() + 'px';

            // 1. 同步所有的设备数据 + 加工任务 + 排队任务
            self.requestAllAssetItems()

            // 2. 监听全屏事件
            self.eventEscListener();

            // 3. 更新
            self.load3DScene()
        },

        methods: {
            ...mapActions({
            }),

            moment,

            /**
             * Introduction 暂停
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/11/02
             */
            pause()
            {
                const self = this;

                self.wee3d.setModelVisible("00_wall_door", true);
                self.wee3d.setModelVisible("00_wall", true);
                self.wee3d.camAnimControl('pause')

                self.isPlay = false;
            },

            /**
             * Introduction 播放
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/11/02
             */
            play()
            {
                const self = this;

                self.wee3d.setModelVisible("00_wall_door", true);
                self.wee3d.setModelVisible("00_wall", true);
                self.wee3d.camAnimControl('play')

                self.isPlay = true;
            },

            /**
             * Introduction 鸟瞰模式
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/11/02
             */
            freeCamera()
            {
                const self = this;

                self.wee3d.setModelVisible("00_wall_door", false);
                self.wee3d.setModelVisible("00_wall", false);
                self.wee3d.freeCamera();

                self.isPlay = false;
            },

            /**
             * Introduction 同步所有的设备数据 + 加工任务 + 排队任务
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/10/12
             */
            requestAllAssetItems()
            {
                this.allAssetItems = assetJson;
                this.workingTaskItems = workingJson;
                this.queueTaskItems = queueJson;
            },

            /**
             * Introduction 获取仪表列表数据
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/10/12
             */
            eventEscListener()
            {
                let self = this;

                if (document.addEventListener) {
                    document.addEventListener('webkitfullscreenchange', function ( e )
                    {
                        if(!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement && !document.fullscreenElement)
                        {
                            if(self.isFullScreen === true)
                            {
                                self.isFullScreen = false;
                            }
                        }
                    }, false);
                    document.addEventListener('mozfullscreenchange', function ( e )
                    {
                        if(!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement && !document.fullscreenElement)
                        {
                            if(self.isFullScreen === true)
                            {
                                self.isFullScreen = false;
                            }
                        }
                    }, false);
                    document.addEventListener('fullscreenchange', function ( e )
                    {
                        if(!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement && !document.fullscreenElement)
                        {
                            if(self.isFullScreen === true)
                            {
                                self.isFullScreen = false;
                            }
                        }
                    }, false);
                    document.addEventListener('MSFullscreenChange', function ( e )
                    {
                        if(!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement && !document.fullscreenElement)
                        {
                            if(self.isFullScreen === true)
                            {
                                self.isFullScreen = false;
                            }
                        }
                    }, false);
                }
            },

            /**
             * Introduction 全屏操作
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/10/12
             */
            fullScreen()
            {
                // 表示本机直接运行
                let element = null;
                if(window == top)
                {
                    element = document.getElementById('wee3dCanvas');
                }
                else
                {
                    element = window.top.frames[0].document.getElementById('wee3dCanvas');
                }

                // 非全屏状态 - 打开全屏
                if ( this.isFullScreen === false )
                {
                    // 全屏状态
                    this.isFullScreen = true;

                    if ( element.msRequestFullscreen )
                    {
                        element.msRequestFullscreen ();
                    }
                    else if ( element.mozRequestFullScreen )
                    {
                        element.mozRequestFullScreen ();
                    }
                    else if ( element.webkitRequestFullscreen )
                    {
                        element.webkitRequestFullscreen ();
                    }
                }
                // 全屏状态 - 返回非全屏
                else
                {
                    // 非全屏状态
                    this.isFullScreen = false;

                    if ( document.msExitFullscreen )
                    {
                        document.msExitFullscreen ();
                    }
                    else if ( document.mozCancelFullScreen )
                    {
                        document.mozCancelFullScreen ();
                    }
                    else if ( document.webkitExitFullscreen )
                    {
                        document.webkitExitFullscreen ();
                    }
                }
            },

            /**
             * Introduction 发送仪表的数据
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/09/08
             * @param id
             */
            load3DScene()
            {
                let self      = this
                self.loading = true;

                self.wee3d   = new Wee3dAPP()
                let fileUrl = 'static/sceneLoader/models/model_3/scene.json'

                self.wee3d.loadSceneUrl(fileUrl, () => {
                    //	相机视口重置
                    self.wee3d.camAnimControl("reset");

                    // 设置对象
                    self.wee3d.setModelVisible("00_wall_door",true);
                    self.wee3d.setModelVisible("00_wall",true);

                    // 如果是采用的第三种类型，则监听相机的位置事件
                    self.eventCamLocation();

                    //	相机控制 "play":播放	"pause":暂停 "stop":停止
                    self.wee3d.camAnimControl('play')
                }, (percent) => {
                    // 加载百分比
                    $('.loadingPercent').LineProgressbar({
                        percentage: percent,
                        fillBackgroundColor: '#fbaf14',
                        height: '100%',
                        radius: '50px'
                    });

                    // 表示已经加载成功了
                    if (percent >= 100)
                    {
                        // 表示已经加载成功了
                        self.loading = false

                        $(".loading").fadeOut("slow");
                    }
                })
            },

            /**
             * Introduction 监听相机事件
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/10/11
             */
            eventCamLocation ()
            {
                const self = this

                setInterval(() =>
                {
                    //	获得相机世界坐标 长度为8的数组 前三个为 xyz 坐标
                    let camTsr     = self.wee3d.getCameraLocation()
                    let currentPos = {x: camTsr[ 0 ], y: camTsr[ 1 ], z: camTsr[ 2 ]}
                    // console.log('pos', camTsr, currentPos);

                    // 分别计算每一个设备的位置
                    self.allAssetItems.forEach(item =>
                    {
                        // 计算相机与镜头的位置(当前桢)
                        let defaultDis = typeof item.showDis !== 'undefined' && item.showDis ? item.showDis : self.defaultDis
                        let dis = tools.calculateCoordinatePosition(currentPos, item.pos)
                        let preDis = 0
                        if(typeof item.prePos !== 'undefined' && item.prePos && JSON.stringify(item.prePos) !== '{}')
                        {
                            preDis = tools.calculateCoordinatePosition(item.prePos, item.pos)
                        }

                        // 表示要显示
                        if(dis < defaultDis)
                        {
                            // 表示相机在靠近 - 显示设备信息
                            if(preDis >= dis)
                            {
                                // 计算左右的相对位置
                                // 表示第 1 、 3 象限
                                let align = "";
                                if(
                                    (item.pos.x <= currentPos.x && item.pos.y <= currentPos.y)
                                    || (item.pos.x >= currentPos.x && item.pos.y >= currentPos.y)
                                )
                                {
                                    align = "left";
                                }
                                else
                                {
                                    align = "right";
                                }

                                // 表示显示左边
                                if(align === 'left')
                                {
                                    const lTarget = self.showLeftAssetItems.filter(v => v.id === item.id)[0];
                                    if(!lTarget)
                                    {
                                        // 计算正在加工的任务
                                        item.assetInfo.workingTask = self.loadItemWorkingTask(item);

                                        // 计算排队的任务
                                        item.assetInfo.queueTask = self.loadItemQueueTask(item);

                                        // 追加数据
                                        self.showLeftAssetItems.unshift(item)
                                    }
                                }
                                else
                                {
                                    const rTarget = self.showRightAssetItems.filter(v => v.id === item.id)[0]
                                    if(!rTarget)
                                    {
                                        // 计算正在加工的任务
                                        item.assetInfo.workingTask = self.loadItemWorkingTask(item);

                                        // 计算排队的任务
                                        item.assetInfo.queueTask = self.loadItemQueueTask(item);

                                        // 追加数据
                                        self.showRightAssetItems.unshift(item)
                                    }
                                }
                            }
                            // 表示相机在远离 - 隐藏设备信息
                            else
                            {
                                self.showLeftAssetItems = self.showLeftAssetItems.filter(v => v.id !== item.id);
                                self.showRightAssetItems = self.showRightAssetItems.filter(v => v.id !== item.id);
                            }
                        }
                        // 表示需要隐藏 - 隐藏设备信息
                        else
                        {
                            self.showLeftAssetItems = self.showLeftAssetItems.filter(v => v.id !== item.id);
                            self.showRightAssetItems = self.showRightAssetItems.filter(v => v.id !== item.id);
                        }

                        // 记录上一次记录下的位置
                        item.prePos = currentPos;
                    })
                }, 500)
            },

            /**
             * Introduction 加载正在进行中的任务
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/10/28
             * @param assetItem
             */
            loadItemWorkingTask(assetItem)
            {
                let workingTask = {"isShowWorkingTask": false, "productName": "", "projectName": "", "marterialName": "", "qty": "", "start_date": "", "end_date": "", "progress": 0};
                if(typeof assetItem.assetInfo.mesNumber !== 'undefined' && assetItem.assetInfo.mesNumber)
                {
                    const target = this.workingTaskItems.filter(item => item.mes === assetItem.assetInfo.mesNumber)[0];
                    if(target)
                    {
                        const startDate = target.start_date;
                        const endDate = target.end_date;
                        let progress = 0;
                        if(new Date().valueOf() >= new Date(endDate).valueOf())
                        {
                            progress = 100;
                        }
                        else if(new Date().valueOf() <= new Date(startDate).valueOf())
                        {
                            progress = 0;
                        }
                        else
                        {
                            progress = ((new Date().valueOf() - new Date(startDate).valueOf()) / (new Date(endDate).valueOf() - new Date(startDate).valueOf())) * 100;
                        }

                        workingTask = {
                            "isShowWorkingTask": true,
                            "productName": target.productName,
                            "projectName": target.projectName,
                            "marterialName": target.marterialName,
                            "qty": target.qty,
                            "start_date": moment(new Date(startDate)).format("YYYY-MM-DD HH:mm"),
                            "end_date": moment(new Date(endDate)).format("YYYY-MM-DD HH:mm"),
                            "progress": Number(progress.toFixed(2))
                        }
                    }
                }

                return workingTask;
            },

            /**
             * Introduction 加载排队的任务
             *
             * @author 刘维中
             * @email weizhong.liu@gmail.com
             * @since 1.0
             * @date 2020/10/28
             * @param assetItem
             */
            loadItemQueueTask(assetItem)
            {
                let queueTask = {"isShowQueueTask": false, "productName": "", "projectName": ""};
                if(typeof assetItem.assetInfo.mesNumber !== 'undefined' && assetItem.assetInfo.mesNumber)
                {
                    const target = this.queueTaskItems.filter(item => item.mes === assetItem.assetInfo.mesNumber)[0];
                    if(target)
                    {
                        queueTask = {
                            "isShowQueueTask": true,
                            "productName": target.productName,
                            "projectName": target.projectName
                        }
                    }
                }

                return queueTask;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .dynamic-map-3d {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100vh;
        background-image: radial-gradient(rgb(125, 152, 196), rgb(24, 32, 45));

        .seemore {
            position: absolute;
            right: 18px;
            top: 20px;
            width: 26px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            border: 1px solid #e8e8e8;
            z-index: 120;
            padding-top: 2px;

            i {
                font-size: 18px;
                line-height: 28px;
                color: white;
            }
        }

        .seemore:hover {
            cursor:pointer;
            background-color: rgba(255, 255, 255, 0.5) !important;
        }

        .wee3d-divider {
            position: relative;
            background: rgba(255, 255, 255, 0.5);
            z-index: 100;
        }

        .wee3d-title {
            position: relative;
            font-size: 14px;
            text-align: left;
            margin-left: 30px;
            margin-top: 25px;
            z-index: 100;

            span {
                font-size: 16px;
                color: rgba(255,255,255, 0.3);
            }

        }

        .asset-parent {
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
        }

        .asset-class {
            width: 360px;
            z-index: 100;
            margin-top: 20px;
            background: rgba(17, 31, 66, 0.5) !important;
            border: none;

            ::v-deep .ant-card-head {
                border-bottom: none !important;
                background: #274184;
                color: #efefef;

                .ant-card-head-title {
                    font-size: 20px;
                    font-weight: 600;
                    text-align: left !important;
                }
            }

            ::v-deep .ant-card-body {
                padding-top: 16px;
                padding-bottom: 10px;
                font-size: 14px;

                .ant-row {
                    color: white;
                    margin-bottom: 5px;
                }

                .ant-col-name {
                    text-align: left !important;
                }

                .ant-col-value {
                    font-size: 16px;
                    font-weight: 600;
                    text-align: right;
                }

                .ant-col-value-left {
                    text-align: left !important;
                }

                .ant-col-value-right {
                    text-align: right !important;
                }
            }
        }

        .wee3d-btn-all {
            position: absolute;
            right: 10px;
            z-index: 1000;
            display: flex !important;
            justify-content: center;
        }

        .wee3d-btn {
            height: 30px;
            line-height: 30px;
            display: flex;
            /*background: rgba(255,255,255,0.1);*/
            padding: 0 10px;
            margin-right: 10px;
            cursor: pointer;

            /*.wee3d-btn-text {*/
            /*    color: rgba(255,255,255,0.3);*/
            /*}*/

            /*.wee3d-btn-text {*/
            /*    color: rgba(255,255,255,0.3);*/
            /*}*/
        }

        /*.wee3d-btn:hover {*/
        /*    cursor:pointer;*/
        /*    background-color: rgba(255, 255, 255, 0.5) !important;*/
        /*    color: #FFFFFF;*/

        /*    .wee3d-btn-text {*/
        /*        color: #FFFFFF;*/
        /*    }*/

        /*    .wee3d-btn-text {*/
        /*        color: #FFFFFF;*/
        /*    }*/
        /*}*/

        /*** 左边的动画 ***/
        .slide-fade-left-item {
            transition: all 1s;
            display: block;
        }
        .slide-fade-left-enter, .slide-fade-left-leave-to {
            opacity: 0;
            transform: translateX(-30px);
        }
        .slide-fade-left-leave-active {
            position: absolute;
            transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .slide-fade-left-enter-active {
            transition: all 3s ease;
        }

        /*** 右边的动画 ***/
        .slide-fade-right-item {
            transition: all 1s;
            display: block;
        }
        .slide-fade-right-enter, .slide-fade-right-leave-to {
            opacity: 0;
            transform: translateX(30px);
        }
        .slide-fade-right-leave-active {
            position: absolute;
            transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .slide-fade-right-enter-active {
            transition: all 3s ease;
        }
    }
</style>
